import { type JSX } from 'react';

import { createFileRoute } from '@tanstack/react-router';

import { ThemesPage } from '@/features/themes';

export const Route = createFileRoute('/banco-de-temas/')({
  component: VisaoGeralTab,
});

function VisaoGeralTab(): JSX.Element {
  return <ThemesPage />;
}
